import { __extends } from 'tslib';
import * as React from 'react';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-error-summary.css';

var getClassNameList = classNames.bind(styles);
var UitkErrorSummary = /** @class */ (function (_super) {
    __extends(UitkErrorSummary, _super);
    function UitkErrorSummary(props) {
        var _this = _super.call(this, props) || this;
        _this.headerRef = React.createRef();
        _this.focusElementOnClick = _this.focusElementOnClick.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        return _this;
    }
    UitkErrorSummary.prototype.componentDidMount = function () {
        this.handleFocus();
    };
    UitkErrorSummary.prototype.componentDidUpdate = function (prevProps) {
        var heading = this.props.heading;
        if (heading !== prevProps.heading) {
            this.handleFocus();
        }
    };
    UitkErrorSummary.prototype.handleFocus = function () {
        var handleUpdate = this.props.handleUpdate;
        if (handleUpdate && typeof handleUpdate === 'function') {
            handleUpdate();
        }
    };
    UitkErrorSummary.prototype.focusElementOnClick = function (e) {
        if (e) {
            e.preventDefault();
        }
        var linkClickFocus = this.props.linkClickFocus;
        var focusEl = linkClickFocus;
        if (focusEl && focusEl.current && typeof focusEl.current.focus === 'function') {
            focusEl.current.focus();
        }
    };
    UitkErrorSummary.prototype.render = function () {
        var _a = this.props, heading = _a.heading, headingLevel = _a.headingLevel, description = _a.description, link = _a.link, linkClickFocusId = _a.linkClickFocusId, domRef = _a.domRef, analytics = _a.analytics;
        var event = null;
        var Tag = '';
        if (headingLevel && headingLevel !== '') {
            Tag = headingLevel;
        }
        else {
            Tag = 'h3';
        }
        return (React.createElement("div", { className: getClassNameList('uitk-error-summary') },
            heading && (React.createElement(Tag, { className: getClassNameList("".concat(UitkErrorSummary.baseClassName, "-heading")), ref: domRef, tabIndex: -1 }, heading)),
            description && (React.createElement("p", { className: getClassNameList("".concat(UitkErrorSummary.baseClassName, "-description")) }, description)),
            link && (React.createElement("div", { className: getClassNameList("".concat(UitkErrorSummary.baseClassName, "-link-wrapper")) },
                React.createElement("a", { className: getClassNameList("".concat(UitkErrorSummary.baseClassName, "-link")), onClick: this.focusElementOnClick.bind(event), href: "#".concat(linkClickFocusId), onClickCapture: analyticsTracker.bind(this, analytics) }, link)))));
    };
    UitkErrorSummary.displayName = 'UitkErrorSummary';
    UitkErrorSummary.baseClassName = 'uitk-error-summary';
    return UitkErrorSummary;
}(React.PureComponent));

export { UitkErrorSummary };
